import React, {Component} from 'react';
import logo from './images/logo.png'
import './App.scss';
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import {Collapse} from "reactstrap";
import MobileNav from "./MobileNav";

class MobileHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        }
    }

    componentDidMount() {
        this.props.history.listen((location, action) => {
            this.closeBurgerMenu();
        })
    }

    userCanViewProjectCategoryNav = () => {
        return /categories/.test(window.location.href);
    };

    toggleBurgerMenu = () => {
        this.setState(state => ({ collapsed: !state.collapsed}));
    };

    closeBurgerMenu = () => {
        this.setState({collapsed: true});
    };

    render() {
        return (
            <>
                {/*  MOBILE HEADER */}
                <div className="header mobile-header">
                    <div className="row">
                        <Link to="/">
                            <img style={{margin: '0 auto', height: '50px'}} src={logo} className="logo-mobile" alt="logo"/>
                        </Link>
                        <FontAwesomeIcon onClick={() => this.toggleBurgerMenu()} className="burger-menu-button" icon={faBars}/>
                    </div>
                    <Collapse className="mt-2" isOpen={!this.state.collapsed}>
                        <div className="row mobile-navbar-container">
                            <div className="col">
                                <MobileNav showSecondaryNav={this.userCanViewProjectCategoryNav()}/>
                            </div>
                        </div>
                    </Collapse>
                </div>
            </>
        );
    }
}

export default withRouter(MobileHeader);
